export const outreachLocations = [
  { name: "Tsabong Mall", area: 'Tsabong' },
  { name: 'Tsabong Primary School', area: 'Tsabong' },
  { name: 'Khawa', area: 'Kgalagadi South' },
  { name: 'Middlepits', area: 'Kgalagadi South' },
  { name: 'Omaoneno', area: 'Kgalagadi South' },
  { name: 'Makopong', area: 'Kgalagadi South' },
]

export const csrGallery = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/pibWsKQ5rJ6mMMinzR5oU9/csr_pics_3.jpg',
    alt: 'Maisha Medical Center outreach tent set up alongside partner stands at a community health day',
    wide: true,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9uBZA2k7pd3NYg2ZR4kiAB/CSR_pics_5.jpg',
    alt: 'Maisha nurse smiling while assisting a young community member at a screening table',
    wide: false,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/72BV1ZtPHHDZocyttRYEvX/csr_pics_4.jpg',
    alt: 'Maisha health worker checking a community member’s blood pressure',
    wide: false,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9hvQP5bZjS1oKvi4Ts3KEy/csr_pics_2.jpg',
    alt: 'Maisha team member recording screening results for a community member',
    wide: false,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tiD5GarZTvEBbLSDkaXurG/CSR_pics.jpg',
    alt: 'Maisha outreach tent at a school offering free health screenings',
    wide: false,
  },
]
